let addedSettingsListenersAlready;

function renderUserSettings() {
	if (!nthAdmin) return;

	document.getElementById('settingsTriggerOverview').classList.remove('hidden');
	const hideHeading = document.getElementById('hideHeading');
	const hideCTAbutton = document.getElementById('hideCTAbutton');
	const hideETstats = document.getElementById('hideETstats');
	const showAggregate = document.getElementById('showAggregate');
	const includeGains = document.getElementById('includeGains');
	const showSmallValues = document.getElementById('showSmallValues');
	const preferPortfolioGraph = document.getElementById('preferPortfolioGraph');
	const portfolioGraphSettingsDiv = document.getElementById('portfolioGraphSettingsDiv');
	const portfolioHeadlineSettingsDiv = document.getElementById('portfolioHeadlineSettingsDiv');

	// Account Statement settings
	const showAccountSummary = document.getElementById('showAccountSummary');
	const showAccountStatement = document.getElementById('showAccountStatement');
	const showTransactionStatement = document.getElementById('showTransactionStatement');
	const transactionStatementHelp = document.getElementById('transactionStatementHelp');

	// Check if transaction statement template exists
	const hasTransactionTemplate = clientData.templates && clientData.templates.some((t) => t && t.includes('_ALL_Account_Statement.html'));

	const showHideUserTabsDiv = document.getElementById('showHideUserTabsDiv');
	const userTabsToggglesDiv = document.getElementById('userTabsToggglesDiv');
	const campaignToggle = document.getElementById('campaignToggle');
	const reportsToggle = document.getElementById('reportsToggle');
	const updatesToggle = document.getElementById('updatesToggle');
	const yourDocsToggle = document.getElementById('yourDocsToggle');
	const dataRoomToggle = document.getElementById('dataRoomToggle');
	const companyCalendarToggle = document.getElementById('companyCalendarToggle');

	const labelUpdatesElem = document.getElementById('labelUpdatesElem');
	const labelReportsElem = document.getElementById('labelReportsElem');
	const labelPortfolioElem = document.getElementById('labelPortfolioElem');
	const labelTeamElem = document.getElementById('labelTeamElem');
	const labelFinStmntsElem = document.getElementById('labelFinStmntsElem');
	const labelCompanyDocsElem = document.getElementById('labelCompanyDocsElem');
	const saveLabelsTabs = document.getElementById('saveLabelsTabs');

	// Portfolio graph headline settings
	const defaultValueMethod = document.getElementById('defaultValueMethod');
	const labelHeadlineTemplate = document.getElementById('labelHeadlineTemplate');
	const labelSubtitleTemplate = document.getElementById('labelSubtitleTemplate');
	const labelTertiaryTemplate = document.getElementById('labelTertiaryTemplate');
	const labelClassHeadlineTemplate = document.getElementById('labelClassHeadlineTemplate');
	const labelClassSubtitleTemplate = document.getElementById('labelClassSubtitleTemplate');
	const labelClassTertiaryTemplate = document.getElementById('labelClassTertiaryTemplate');
	const saveHeadlineLabels = document.getElementById('saveHeadlineLabels');

	// labelOwnershipElem.placeholder = clientData.use_fund_language ? "Percent" : "Ownership";
	// labelShareholdersElem.placeholder = clientData.use_fund_language ? "Investors" : "Shareholders";
	// labelInvestmentsElem.placeholder = clientData.use_real_estate_language ? "Properties" : clientData.use_fund_language ? "Funds" : "Classes";

	if (!clientData.language) clientData.language = {};
	let language = clientData.language;
	if (language.label_updates_tab) labelUpdatesElem.value = language.label_updates_tab;
	if (language.label_reports_tab) labelReportsElem.value = language.label_reports_tab;
	if (language.label_portfolio_tab) labelPortfolioElem.value = language.label_portfolio_tab;
	if (language.label_team_tab) labelTeamElem.value = language.label_team_tab;
	if (language.label_financial_statements) labelFinStmntsElem.value = language.label_financial_statements;
	if (language.label_company_documents) labelCompanyDocsElem.value = language.label_company_documents;

	let flags = clientData.flags || {};
	hideHeading.checked = flags.hide_heading;
	hideCTAbutton.checked = flags.hide_cta_button;
	hideETstats.checked = flags.hide_ET_stats;
	showAggregate.checked = flags.show_aggregate;
	includeGains.checked = flags.include_gains;
	showSmallValues.checked = flags.show_last_invited;
	preferPortfolioGraph.checked = flags.prefer_portfolio_graph;

	// Account Statement settings
	showAccountSummary.checked = flags.show_account_summary || false;
	showAccountStatement.checked = flags.show_account_statement || false;
	showTransactionStatement.checked = flags.show_transaction_statement || false;

	// Disable transaction statement toggle if no template exists
	if (!hasTransactionTemplate) {
		showTransactionStatement.disabled = true;
		showTransactionStatement.checked = false;
		transactionStatementHelp.classList.remove('hidden');
	}

	// Show/hide portfolio graph settings based on toggle state
	if (flags.prefer_portfolio_graph) {
		portfolioGraphSettingsDiv.hidden = false;
	}

	// Show portfolio headline settings when aggregate or portfolio graph is enabled
	if (flags.show_aggregate || flags.prefer_portfolio_graph) {
		portfolioHeadlineSettingsDiv.hidden = false;
	}

	let tabs = clientData.tabs || {};

	// Dynamically populate calculation method dropdown from registry
	if (window.calculatorRegistry) {
		const calculators = window.calculatorRegistry.listAvailable();
		// Clear existing options and add default
		defaultValueMethod.innerHTML = '<option value="">Private Company (In-the-Money Value)</option>';
		// Add all registered calculators except the default (private_company_409a)
		calculators.forEach((calc) => {
			if (calc.methodId === 'private_company_409a') return;
			const option = document.createElement('option');
			option.value = calc.methodId;
			option.textContent = calc.displayName;
			defaultValueMethod.appendChild(option);
		});
	}

	// Set current value method from flags and initialize Materialize select
	if (flags.default_value_method) {
		defaultValueMethod.value = flags.default_value_method;
	}
	M.FormSelect.init(defaultValueMethod);

	// Populate headline template fields from language config
	if (language.headline_template) labelHeadlineTemplate.value = language.headline_template;
	if (language.headline_subtitle_template) labelSubtitleTemplate.value = language.headline_subtitle_template;
	if (language.headline_tertiary_template) labelTertiaryTemplate.value = language.headline_tertiary_template;
	if (language.class_headline_template) labelClassHeadlineTemplate.value = language.class_headline_template;
	if (language.class_subtitle_template) labelClassSubtitleTemplate.value = language.class_subtitle_template;
	if (language.class_tertiary_template) labelClassTertiaryTemplate.value = language.class_tertiary_template;

	campaignToggle.checked = tabs.show_campaign;
	reportsToggle.checked = !tabs.hide_reports;
	updatesToggle.checked = !tabs.hide_updates;
	yourDocsToggle.checked = !tabs.hide_your_docs;
	dataRoomToggle.checked = tabs.show_data_room;
	companyCalendarToggle.checked = tabs.show_small_values;

	// Select all toggle inputs
	const toggles = document.querySelectorAll('#editSettingsOverview input[type="checkbox"]');

	// Add event listeners to each toggle
	if (!addedSettingsListenersAlready) {
		addedSettingsListenersAlready = true;
		showHideUserTabsDiv.addEventListener('click', function (e) {
			if (this.innerHTML.startsWith('Show')) {
				userTabsToggglesDiv.hidden = false;
				this.innerHTML = 'Hide Toggles and Labels for User Tabs';
			} else {
				userTabsToggglesDiv.hidden = true;
				this.innerHTML = 'Show Toggles and Labels for User Tabs';
			}
		});

		saveLabelsTabs.addEventListener('click', function (e) {
			const labels = {
				label_updates_tab: labelUpdatesElem.value,
				label_reports_tab: labelReportsElem.value,
				label_portfolio_tab: labelPortfolioElem.value,
				label_team_tab: labelTeamElem.value,
				label_financial_statements: labelFinStmntsElem.value,
				label_company_documents: labelCompanyDocsElem.value,
			};

			Object.keys(labels).forEach((key) => {
				if (labels[key]) language[key] = labels[key];
				else delete language[key];
			});

			sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));

			let apiUrl = 'https://api.nthround.io/portal/clientConfig/language';
			let params = { client: client, userid: authedUser, cookie: cookie };
			params.language = clientData.language;
			axios
				.patch(apiUrl, { body: 'body' }, { params })
				.then(function (response) {
					console.log(response);
					showToast('success-toast', 'All labels updated. On closing this modal, your browser will refresh.');
					const editSettingsOverview = document.getElementById('editSettingsOverview');
					M.Modal.getInstance(editSettingsOverview).options.onCloseEnd = () => {
						location.reload();
					};
				})
				.catch(function (error) {
					console.error(error);
				});
		});

		saveHeadlineLabels.addEventListener('click', function (e) {
			const originalText = saveHeadlineLabels.innerHTML;
			saveHeadlineLabels.innerHTML = 'Saving...';
			saveHeadlineLabels.classList.add('disabled');

			const headlineLabels = {
				headline_template: labelHeadlineTemplate.value,
				headline_subtitle_template: labelSubtitleTemplate.value,
				headline_tertiary_template: labelTertiaryTemplate.value,
				class_headline_template: labelClassHeadlineTemplate.value,
				class_subtitle_template: labelClassSubtitleTemplate.value,
				class_tertiary_template: labelClassTertiaryTemplate.value,
			};

			Object.keys(headlineLabels).forEach((key) => {
				if (headlineLabels[key]) language[key] = headlineLabels[key];
				else delete language[key];
			});

			sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));

			let apiUrl = 'https://api.nthround.io/portal/clientConfig/language';
			let params = { client: client, userid: authedUser, cookie: cookie };
			params.language = clientData.language;
			axios
				.patch(apiUrl, { body: 'body' }, { params })
				.then(function (response) {
					console.log(response);
					saveHeadlineLabels.innerHTML = 'Saved!';
					showToast('success-toast', 'Headline labels updated.');
					// Re-enable the button after a short delay so user can make more edits
					setTimeout(function () {
						saveHeadlineLabels.innerHTML = originalText;
						saveHeadlineLabels.classList.remove('disabled');
					}, 1500);
				})
				.catch(function (error) {
					console.error(error);
					showToast('error-toast', 'Error updating headline labels. Please try again.');
					saveHeadlineLabels.innerHTML = originalText;
					saveHeadlineLabels.classList.remove('disabled');
				});
		});

		toggles.forEach((toggle) => {
			toggle.addEventListener('change', (event) => {
				const toggleId = event.target.id;
				const isChecked = event.target.checked;

				// Validate transaction statement toggle requires template
				if (toggleId === 'showTransactionStatement' && isChecked && !hasTransactionTemplate) {
					event.target.checked = false;
					showToast('error-toast', 'Transaction Statement requires an HTML template to be uploaded first.');
					return;
				}

				// Define mappings for toggles and their respective APIs
				const tabsMapping = {
					hideHeading: { key: 'hide_heading', api: 'flags', negate: false },
					hideCTAbutton: { key: 'hide_cta_button', api: 'flags', negate: false },
					hideETstats: { key: 'hide_ET_stats', api: 'flags', negate: false },
					showAggregate: { key: 'show_aggregate', api: 'flags', negate: false },
					includeGains: { key: 'include_gains', api: 'flags', negate: false },
					showSmallValues: { key: 'show_small_values', api: 'flags', negate: false },
					autoJoin: { key: 'auto_join', api: 'flags', negate: false },
					preferPortfolioGraph: { key: 'prefer_portfolio_graph', api: 'flags', negate: false },

					// Account Statement flags
					showAccountSummary: { key: 'show_account_summary', api: 'flags', negate: false },
					showAccountStatement: { key: 'show_account_statement', api: 'flags', negate: false },
					showTransactionStatement: { key: 'show_transaction_statement', api: 'flags', negate: false },

					campaignToggle: { key: 'show_campaign', api: 'tabs', negate: false },
					reportsToggle: { key: 'hide_reports', api: 'tabs', negate: true },
					updatesToggle: { key: 'hide_updates', api: 'tabs', negate: true },
					yourDocsToggle: { key: 'hide_your_docs', api: 'tabs', negate: true },
					dataRoomToggle: { key: 'show_data_room', api: 'tabs', negate: false },
					companyCalendarToggle: { key: 'show_company_calendar', api: 'tabs', negate: false },
				};

				// Show/hide portfolio graph settings when toggle changes
				if (toggleId === 'preferPortfolioGraph') {
					portfolioGraphSettingsDiv.hidden = !isChecked;
				}

				// Show/hide portfolio headline settings when aggregate or portfolio graph changes
				if (toggleId === 'showAggregate' || toggleId === 'preferPortfolioGraph') {
					const aggregateOn = showAggregate.checked;
					const graphOn = preferPortfolioGraph.checked;
					portfolioHeadlineSettingsDiv.hidden = !aggregateOn && !graphOn;
				}

				if (!clientData.tabs) clientData.tabs = {};
				if (!clientData.flags) clientData.flags = {};

				// Check if toggleId matches a mapping
				let api;
				if (tabsMapping[toggleId]) {
					const { key, api: newApi, negate } = tabsMapping[toggleId];
					api = newApi; // Set the correct API
					if (api == 'tabs')
						clientData.tabs[key] = negate ? !isChecked : isChecked; // Apply the toggle state with negation if needed
					else if (api == 'flags') clientData.flags[key] = negate ? !isChecked : isChecked;
				} else {
					console.error(`Unknown toggleId: ${toggleId}`);
				}

				sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));

				let apiUrl = 'https://api.nthround.io/portal/clientConfig/' + api;
				let params = { client: client, userid: authedUser, cookie: cookie };
				if (api == 'tabs') params.tabs = clientData.tabs;
				else if (api == 'flags') params.flags = clientData.flags;
				axios
					.patch(
						apiUrl,
						{
							body: 'body',
						},
						{
							params,
						}
					)
					.then(function (response) {
						console.log(response);
						showToast('success-toast', 'Settings updated. On closing this modal, your browser will refresh.');
						const editSettingsOverview = document.getElementById('editSettingsOverview');
						M.Modal.getInstance(editSettingsOverview).options.onCloseEnd = () => {
							location.reload();
						};
					})
					.catch(function (error) {
						console.error(error);
					});
			});
		});

		// Auto-preview: renders inline below portfolio and class template inputs
		let previewDebounceTimer = null;
		let lastPreviewResult = null;

		function runHeadlinePreview() {
			if (typeof window.previewHeadlines !== 'function') return;

			const templates = {
				template: labelHeadlineTemplate.value,
				subtitleTemplate: labelSubtitleTemplate.value,
				tertiaryTemplate: labelTertiaryTemplate.value,
				classTemplate: labelClassHeadlineTemplate.value,
				classSubtitleTemplate: labelClassSubtitleTemplate.value,
				classTertiaryTemplate: labelClassTertiaryTemplate.value,
			};

			const result = window.previewHeadlines(templates);
			if (!result) return;
			lastPreviewResult = result;

			const ph = result.portfolioHeadline;

			// Render portfolio headline preview below each input
			function renderPreviewLine(id, content) {
				const el = document.getElementById(id);
				if (!el) return;
				if (content) {
					el.innerHTML = '<div class="bg-grey-lightest rounded px-3 py-2 text-sm">' + content + '</div>';
				} else {
					el.innerHTML = '';
				}
			}

			renderPreviewLine('previewPortfolioMain', ph.main);
			renderPreviewLine('previewPortfolioSubtitle', ph.subtitle);
			renderPreviewLine('previewPortfolioTertiary', ph.tertiary);

			// Render class headline previews below each input
			// Combine all classes into one preview per line
			let classMainHtml = '',
				classSubHtml = '',
				classTerHtml = '';
			result.classHeadlines.forEach(function (ch, i) {
				const sep = i > 0 ? '<div style="border-top:1px solid #ddd;margin:6px 0;"></div>' : '';
				const label = '<div class="text-xs text-secondary">' + ch.className + ' (' + ch.classKey + ')</div>';
				if (ch.headline.main) classMainHtml += sep + label + '<div>' + ch.headline.main + '</div>';
				if (ch.headline.subtitle) classSubHtml += sep + label + '<div>' + ch.headline.subtitle + '</div>';
				if (ch.headline.tertiary) classTerHtml += sep + label + '<div>' + ch.headline.tertiary + '</div>';
			});
			renderPreviewLine('previewClassMain', classMainHtml);
			renderPreviewLine('previewClassSubtitle', classSubHtml);
			renderPreviewLine('previewClassTertiary', classTerHtml);
		}

		function debouncedPreview() {
			clearTimeout(previewDebounceTimer);
			previewDebounceTimer = setTimeout(runHeadlinePreview, 300);
		}

		// Auto-preview on template input changes
		document.querySelectorAll('.headline-template-input').forEach(function (input) {
			input.addEventListener('input', debouncedPreview);
		});

		// Run initial preview for the currently-viewed user
		try {
			runHeadlinePreview();
		} catch (e) {
			console.warn('Headline preview error:', e);
		}

		// Variable insertion dropdown handlers
		// Helpers to look up variable values, formulas, and format for display
		function getVarValue(scope, varName) {
			if (!lastPreviewResult) return null;
			if (scope === 'class') {
				for (let i = 0; i < (lastPreviewResult.classVars || []).length; i++) {
					let cv = lastPreviewResult.classVars[i];
					if (cv.vars[varName] !== undefined && cv.vars[varName] !== null) return cv.vars[varName];
				}
				return null;
			}
			return lastPreviewResult.vars?.[varName] ?? null;
		}

		function getVarFormula(scope, varName) {
			if (!lastPreviewResult) return '';
			if (scope === 'class') {
				for (let i = 0; i < (lastPreviewResult.classVars || []).length; i++) {
					let cv = lastPreviewResult.classVars[i];
					if (cv.vars._formulas?.[varName]) return cv.vars._formulas[varName];
				}
				return '';
			}
			return lastPreviewResult.vars?._formulas?.[varName] || '';
		}

		function formatVarValue(varName, val) {
			if (val === null || val === undefined) return '';
			let types = lastPreviewResult?.variableTypes || {};
			let type = types[varName];
			if (type === 'currency' && typeof val === 'number') return '$' + val.toLocaleString('en-US', { maximumFractionDigits: 0 });
			if (type === 'number' && typeof val === 'number') return val.toLocaleString('en-US');
			if (type === 'multiplier' && typeof val === 'number') return val.toFixed(2) + 'x';
			if (type === 'percentage' && typeof val === 'number') return (val * 100).toFixed(2) + '%';
			if (typeof val === 'string' && val.length > 20) return val.substring(0, 20) + '…';
			return String(val);
		}

		// Get available variables from the preview result (only shows vars with actual values)
		function getAvailableVars(scope) {
			if (!lastPreviewResult) return [];
			if (scope === 'class') {
				// Merge variable keys from all class variable maps, keep only those with values
				const allClassVarKeys = new Set();
				(lastPreviewResult.classVars || []).forEach(function (cv) {
					Object.keys(cv.vars).forEach(function (k) {
						if (k.startsWith('_')) return; // skip internal vars
						if (cv.vars[k] !== null && cv.vars[k] !== undefined) allClassVarKeys.add(k);
					});
				});
				return Array.from(allClassVarKeys).sort();
			} else {
				// Portfolio vars: show only those with non-null values
				const vars = lastPreviewResult.vars || {};
				return Object.keys(vars)
					.filter(function (k) {
						if (k.startsWith('_')) return false; // skip internal vars
						return vars[k] !== null && vars[k] !== undefined;
					})
					.sort();
			}
		}

		// Track which input field was last focused per scope, and save cursor position
		const lastFocusedInput = { portfolio: 'labelHeadlineTemplate', class: 'labelClassHeadlineTemplate' };
		const lastCursorPos = {};

		document.querySelectorAll('.headline-template-input').forEach(function (input) {
			input.addEventListener('focus', function () {
				const scope = this.getAttribute('data-scope');
				if (scope) lastFocusedInput[scope] = this.id;
			});
			// Save cursor position before focus is lost (e.g. clicking Insert Variable button)
			input.addEventListener('blur', function () {
				lastCursorPos[this.id] = { start: this.selectionStart, end: this.selectionEnd };
			});
		});

		function insertHeadlineVariable(targetId, varName) {
			const input = document.getElementById(targetId);
			if (!input) return;
			const saved = lastCursorPos[targetId];
			const cursorPos = saved ? saved.start : input.value.length;
			const selEnd = saved ? saved.end : cursorPos;
			const textBefore = input.value.substring(0, cursorPos);
			const textAfter = input.value.substring(selEnd);
			const insertion = '{{' + varName + '}}';
			input.value = textBefore + insertion + textAfter;
			input.focus();
			input.selectionStart = input.selectionEnd = cursorPos + insertion.length;
			// Trigger Materialize label update and preview refresh
			M.updateTextFields();
			debouncedPreview();
		}

		document.querySelectorAll('.headline-var-insert-btn').forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				const scope = this.getAttribute('data-scope');
				const dropdown = this.nextElementSibling;
				if (!dropdown) return;

				// Toggle dropdown
				if (!dropdown.classList.contains('hidden')) {
					dropdown.classList.add('hidden');
					return;
				}

				// Close all other dropdowns
				document.querySelectorAll('.headline-var-dropdown').forEach((d) => d.classList.add('hidden'));

				// Populate dropdown with only variables that have values for the current user
				const vars = getAvailableVars(scope);
				if (!vars.length) {
					dropdown.innerHTML = '<div style="padding:4px 12px;color:#999;">No variables available</div>';
					dropdown.classList.remove('hidden');
					return;
				}
				dropdown.innerHTML = vars
					.map(function (v) {
						let val = getVarValue(scope, v);
						let formula = getVarFormula(scope, v);
						let fmtVal = formatVarValue(v, val);
						return (
							'<div class="headline-var-option" data-var="' +
							v +
							'" style="padding:6px 12px;cursor:pointer;">' +
							'<div style="display:flex;justify-content:space-between;gap:12px;">' +
							'<span style="font-weight:500;">' +
							v +
							'</span>' +
							(fmtVal ? '<span style="color:#666;font-size:12px;">' + fmtVal + '</span>' : '') +
							'</div>' +
							(formula ? '<div style="font-size:11px;color:#999;margin-top:1px;">' + formula + '</div>' : '') +
							'</div>'
						);
					})
					.join('');

				// Add click handlers to options
				dropdown.querySelectorAll('.headline-var-option').forEach(function (opt) {
					opt.addEventListener('click', function () {
						insertHeadlineVariable(lastFocusedInput[scope], this.getAttribute('data-var'));
						dropdown.classList.add('hidden');
					});
					opt.addEventListener('mouseenter', function () {
						this.style.backgroundColor = '#f0f0f0';
					});
					opt.addEventListener('mouseleave', function () {
						this.style.backgroundColor = '';
					});
				});

				dropdown.classList.remove('hidden');
			});
		});

		// Close dropdowns when clicking outside
		document.addEventListener('click', function (e) {
			if (!e.target.closest('.headline-var-insert-btn') && !e.target.closest('.headline-var-dropdown')) {
				document.querySelectorAll('.headline-var-dropdown').forEach((d) => d.classList.add('hidden'));
			}
		});

		// Handle calculation method dropdown change
		defaultValueMethod.addEventListener('change', function (e) {
			const value = e.target.value;
			if (!clientData.flags) clientData.flags = {};

			// If empty value (Default option), remove the flag; otherwise set it
			if (value) {
				clientData.flags.default_value_method = value;
			} else {
				delete clientData.flags.default_value_method;
			}

			sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));

			let apiUrl = 'https://api.nthround.io/portal/clientConfig/flags';
			let params = { client: client, userid: authedUser, cookie: cookie };
			params.flags = clientData.flags;
			axios
				.patch(apiUrl, { body: 'body' }, { params })
				.then(function (response) {
					console.log(response);
					showToast('success-toast', 'Calculation method updated. On closing this modal, your browser will refresh.');
					const editSettingsOverview = document.getElementById('editSettingsOverview');
					M.Modal.getInstance(editSettingsOverview).options.onCloseEnd = () => {
						location.reload();
					};
				})
				.catch(function (error) {
					console.error(error);
				});
		});
	}
}

export { renderUserSettings };
